<template>
  <div>
    <div v-if="hasTimeInputted">
      <div class="mt-5 mb-2" v-if="listAvailableCandidates.length">
        <h4>
          <strong>Available {{ wordUsedForCandidates }}</strong>
        </h4>
        <h5 v-if="isSelectInterestedCandidate">
          Please select {{ wordUsedForCandidates }} who you are interested in
        </h5>
      </div>
      <div v-else class="mt-3">
        <h4>
          {{ textSelfSelectNobodyAvailable }}
        </h4>
        <div
          v-if="
            listPartlyAvailableCandidates &&
            listPartlyAvailableCandidates.length
          "
        >
          <h4>
            Here are some candidates who have availability at other times on
            this date
          </h4>
          <div
            v-for="(candidateBlock, index) in listPartlyAvailableCandidates"
            :key="'partly-available-' + index"
          >
            <hr />
            <JobFillerInfo
              :jobFiller="candidateBlock.candidate"
              :listFields="shiftJobSelectionProfileFields"
              :listAdditionalInfo="candidateInfoSelectionFields"
              :isFavorite="
                listFavoriteCandidateIds.includes(candidateBlock.candidate.id)
              "
            />
            <h5><b>Available time</b></h5>
            <ul>
              <li
                v-for="(block, blockIndex) in candidateBlock.blocks"
                :key="'block-' + index + '-' + blockIndex"
              >
                From {{ djangotimeformatAMPM(block.startTime) }} to
                {{ djangotimeformatAMPM(block.endTime) }}
              </li>
            </ul>
            <p v-if="candidateBlock.isExceed" class="warning-text mt-1">
              Warning: Exceed maximum number of daily jobs
            </p>
          </div>
        </div>
      </div>

      <div
        class="collapse-expand-button-container"
        v-if="listAvailableCandidates.length >= 2 && isMultiSelection"
      >
        <div class="expand-btn mb-0">
          <button
            class="mylisting-button secondary-button"
            @click="listSelectedCandidates = listAvailableCandidates"
          >
            {{ getLabelByKeys("BUTTONS.SELECT_ALL") }}
          </button>
        </div>
        <div class="collapse-btn mb-0">
          <button
            class="mylisting-button dark-button"
            @click="listSelectedCandidates = []"
          >
            {{ getLabelByKeys("BUTTONS.UNSELECT_ALL") }}
          </button>
        </div>
      </div>
      <div
        v-for="candidate in listAvailableCandidates"
        :key="'Sorted candidate ' + candidate.id"
        :class="{
          'selected-candidate': hasUnselectCandidateBtn(candidate),
        }"
      >
        <hr />
        <JobFillerInfo
          :jobFiller="candidate"
          :listFields="shiftJobSelectionProfileFields"
          :listAdditionalInfo="candidateInfoSelectionFields"
          :isFavorite="listFavoriteCandidateIds.includes(candidate.id)"
        />
        <div v-if="candidatesCanSetRate && candidate.rate">
          <b>Rate:</b> ${{ candidate.rate }}/h
        </div>
        <button
          v-if="hasUnselectCandidateBtn(candidate)"
          class="btn btn-primary mt-2"
          @click="handleUnselectCandidates(candidate)"
        >
          Unselect
        </button>
        <button
          v-if="hasSelectCandidateBtn(candidate)"
          class="btn btn-primary mt-2"
          @click="handleSelectCandidate(candidate)"
        >
          Select
        </button>
      </div>
      <button
        v-if="numberOfBooking > 1 && !isSelectInterestedCandidate"
        class="submit-button mylisting-button dark-button mt-2"
        data-index="1"
        @click="$emit('selectIndividual')"
      >
        Select candidate for each individual booking
      </button>
    </div>
    <div v-else class="mt-3">
      <div
        v-if="
          listPartlyAvailableCandidates && listPartlyAvailableCandidates.length
        "
      >
        <h4>
          <strong>Available {{ wordUsedForCandidates }}</strong>
        </h4>
        <h5 v-if="isSelectInterestedCandidate">
          Please select {{ wordUsedForCandidates }} who you are interested in
        </h5>
        <div
          v-for="(candidateBlock, index) in listPartlyAvailableCandidates"
          :key="'partly-available-' + index"
          :class="{
            'selected-candidate': hasUnselectCandidateBtn(
              candidateBlock.candidate
            ),
          }"
        >
          <hr />
          <JobFillerInfo
            :jobFiller="candidateBlock.candidate"
            :listFields="shiftJobSelectionProfileFields"
            :listAdditionalInfo="candidateInfoSelectionFields"
            :isFavorite="
              listFavoriteCandidateIds.includes(candidateBlock.candidate.id)
            "
          />
          <div
            v-if="
              mapUserIdBadgeIds &&
              mapUserIdBadgeIds[candidateBlock.candidate.id]
            "
          >
            <Badges
              :badgeIds="mapUserIdBadgeIds[candidateBlock.candidate.id]"
            />
          </div>
          <div
            v-if="
              mapUserIdReviews && mapUserIdReviews[candidateBlock.candidate.id]
            "
          >
            <ReviewInfo
              :reviewInfo="mapUserIdReviews[candidateBlock.candidate.id]"
            />
          </div>
          <h5><b>Available time</b></h5>
          <ul>
            <li
              v-for="(block, blockIndex) in candidateBlock.blocks"
              :key="'block-' + index + '-' + blockIndex"
            >
              From {{ djangotimeformatAMPM(block.startTime) }} to
              {{ djangotimeformatAMPM(block.endTime) }}
            </li>
          </ul>
          <div v-if="candidatesCanSetRate && candidate.rate">
            <b>Rate:</b> ${{ candidate.rate }}/h
          </div>
          <p v-if="candidateBlock.isExceed" class="warning-text mt-1">
            Warning: Exceed maximum number of daily jobs
          </p>
          <button
            v-if="hasUnselectCandidateBtn(candidateBlock.candidate)"
            class="btn btn-primary mt-2"
            @click="handleUnselectCandidates(candidateBlock.candidate)"
          >
            Unselect
          </button>
          <button
            v-if="hasSelectCandidateBtn(candidateBlock.candidate)"
            class="btn btn-primary mt-2"
            @click="handleSelectCandidate(candidateBlock.candidate)"
          >
            Select
          </button>
        </div>
      </div>
      <div v-else>
        <h4>
          {{ textSelfSelectNobodyAvailable }}
        </h4>
      </div>
    </div>
  </div>
</template>
<script>
import JobFillerInfo from "../JobFillerInfo.vue";
import Badges from "../../users/Badges";
import ReviewInfo from "../../users/ReviewInfo.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CandidateSelectionSection",
  components: {
    JobFillerInfo,
    Badges,
    ReviewInfo,
  },
  props: {
    listAvailableCandidates: Array,
    listPartlyAvailableCandidates: Array,
    listFavoriteCandidateIds: Array,
    numberOfBooking: Number,
    value: Array,
    booking: {
      type: Object,
      default: () => {},
    },
    isSelectInterestedCandidate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "wordUsedForCandidates",
      "textSelfSelectNobodyAvailable",
      "shiftJobSelectionProfileFields",
      "clientCanSelectMultipleCandidates",
      "candidateInfoSelectionFields", // list candidate info to show for avaialble candidates
      "candidatesCanSetRate",
    ]),
    mapUserIdBadgeIds() {
      if (!this.candidateInfoSelectionFields) {
        return {};
      }
      const result = {};
      this.candidateInfoSelectionFields.forEach((item) => {
        if (item.user_badges__agency_badge_id) {
          result[item.id] = item.user_badges__agency_badge_id;
        }
      });
      return result;
    },
    mapUserIdReviews() {
      if (!this.candidateInfoSelectionFields) {
        return {};
      }
      const result = {};
      this.candidateInfoSelectionFields.forEach((item) => {
        if (item.review_records) {
          result[item.id] = item.review_records;
        }
      });
      return result;
    },
    isMultiSelection() {
      return (
        this.clientCanSelectMultipleCandidates ||
        this.isSelectInterestedCandidate
      );
    },
    hasTimeInputted() {
      return (
        this.getTimeString(this.booking.start_time) &&
        this.getTimeString(this.booking.end_time)
      );
    },
  },
  data() {
    return {
      listSelectedCandidates: this.value || [],
    };
  },
  methods: {
    ...mapActions(['setSelectedCandidate']),
    handleUnselectCandidates(candidate) {
      this.listSelectedCandidates = this.listSelectedCandidates.filter(
        (cand) => cand.id !== candidate.id
      );
      this.$emit("input", this.listSelectedCandidates);
    },
    handleSelectCandidate(candidate) {
      this.setSelectedCandidate(candidate);
      this.listSelectedCandidates.push(candidate);
      this.$emit("input", this.listSelectedCandidates);
    },
    hasSelectCandidateBtn(candidate) {
      if (this.isMultiSelection) {
        return !this.listSelectedCandidates.some(
          (cand) => cand.id === candidate.id
        );
      } else {
        return !this.listSelectedCandidates.length;
      }
    },
    hasUnselectCandidateBtn(candidate) {
      return this.listSelectedCandidates.some(
        (cand) => cand.id === candidate.id
      );
    },
  },
};
</script>

<style scoped>
.selected-candidate {
  background-color: rgb(227 226 226);
}
</style>



// WEBPACK FOOTER //
// src/components/common/bookings/CandidateSelectionSection.vue